<template>
  <!---全体を囲む--->
  <div class="content-wrapper">
    <div class="carshare_header">
      <div class="center">
        <p class="title">{{ car_share.Station.Name }}</p>
        <p class="address">{{ car_share.Address }}</p>
      </div>
    </div>
    <div class="location-info">
      <div v-if="car_share.Link" class="info-list">
        <a
          v-if="car_share.Corporation.Name == 'dカーシェア'"
          @click="
            goToExternalLink(
              car_share.Link +
                '&utm_source=dcarsharepartner&utm_medium=emot&utm_campaign=dcarshare_202006_ptr'
            )
          "
        >
          <div class="list-item">予約・手配する</div>
        </a>
        <a v-else @click="goToExternalLink(car_share.Link)">
          <div class="list-item">予約・手配する</div>
        </a>
        <div class="vehicle_table">
          <p class="car_list">車両一覧</p>
          <p v-for="car in car_share.Car" :key="car.code">
            {{ car.Name }} {{ car.capacity }}人乗り
          </p>
        </div>
      </div>
    </div>
    <div>
      <button class="bottom-button" @click="ncGotoPlaceCarShare(car_share)">
        ここへ行く
      </button>
    </div>
  </div>
</template>

<script>
import storeJS from "@/store";

// ネイティブから送られてくる情報をストアへ格納
window.jcSetCarShareInfo = function (info) {
  storeJS.commit("car_share/setCarShare", info);
};

import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("car_share", ["car_share"]),
  },
};
</script>

<style lang="scss" scoped>
.content-wrapper {
  padding-bottom: 65px; /* 「ここへ行く」がある分、パディングを取る必要がある */
}

.carshare_header {
  height: 64px;
  z-index: 99;
  padding: 0px 0px;
  left: 0;
  right: 0;
  top: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-bottom: 1px solid #f5f5f5;
  .center {
    width: 96%;
    padding: 0 2%;
    .title {
      font: inherit;
      font-size: 16px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-bottom: 3px;
    }
    .address {
      font-size: 13px;
      padding-top: 5px;
      color: #888888;
    }
  }
}

.masterbook_division {
  border-bottom: 1px solid #e0e0e0;
}

.ribbon {
  background: #fdd000;
  p {
    padding: 5px;
    padding-left: 30px;
    font-weight: bold;
    font-size: 3vw;
  }
}

.location-info {
  a {
    width: 100%;
  }
}

.info-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  // height: 10vh;
  padding: 2vh 3%;
}

.list-item {
  font-size: 13px;
  color: black;
  font-weight: bold;
  width: 100%;
  text-align: center;
  border: 1px solid #e7e7e7;
  padding: 13px 0;
  margin: 0 auto;
}

.list-item:first-child {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.list-item:last-child {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.car_list {
  font-weight: bold;
  font-size: 15px;
}

.vehicle_table {
  width: 100%;
  padding-top: 2vh;
  font-size: 15px;
  p {
    padding: 3px 0;
  }
}

.list-item__header {
  font-size: 3vw;
  width: 35%;
  display: inline-block;
  text-align: center;
}

.open_for_business {
  background: #61d101;
  color: white;
  padding: 2px 4px;
  border-radius: 2px;
}

.bottom-button {
  background: #ffb206;
  width: 100%;
  display: block;
  border: none;
  /* margin: 0.5vw auto; */
  font-size: 13px;
  color: white;
  font-weight: bold;
  height: 42px;
  position: fixed;
  bottom: 0;
  border-radius: 0px 0px 10px 10px;
}
</style>
